module.exports = __webpack_public_path__ + "img/数据大屏3.1d3935bb.png";